import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ContractTypeModel } from './contractType.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class ContractTypeService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetContractTypeList(contractTypeGroupHashId: string, input?: DataListModel): Observable<IAPIResponse> {
    let personHashId = this.authService.GetPersonHashId();
    let getContractTypeUrl = WeGoConfig.API_GET_CONTRACT_TYPE_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getContractTypeUrl = getContractTypeUrl + "?" + queryString + "&contractTypeGroupHashId=" + contractTypeGroupHashId;
    }
    else {
      getContractTypeUrl = getContractTypeUrl + "?contractTypeGroupHashId=" + contractTypeGroupHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getContractTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public GetContractTypeByHashId(contractTypeHashId: string): Observable<IAPIResponse> {
    let getContractTypeUrl = WeGoConfig.API_GET_CONTRACT_TYPE_BY_HASH + "?contractTypeHashId=" + contractTypeHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getContractTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddContractType(contractTypeModel: ContractTypeModel): Observable<IAPIResponse> {
    let body = contractTypeModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_CONTRACT_TYPE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteContractType(selectedcontractTypeHashId: string[], contractTypeGroupHashId: string): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let getContractTypeUrl = WeGoConfig.API_POST_DELETE_CONTRACT_TYPE;

    getContractTypeUrl = getContractTypeUrl + "?contractTypeGroupHashId=" + contractTypeGroupHashId;

    return this.http.post(getContractTypeUrl, selectedcontractTypeHashId, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportContractTypeList(contractTypeGroupHashId: string, input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getContractUrl = WeGoConfig.API_EXPORT_CONTRACT_TYPE_LIST;
    if (queryString) {
      getContractUrl = getContractUrl + "?" + queryString + "&contractTypeGroupHashId=" + contractTypeGroupHashId;
    }
    else {
      getContractUrl = getContractUrl + "?contractTypeGroupHashId=" + contractTypeGroupHashId;
    }
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getContractUrl, options);
  }

  public GetContractTypeHistory(versionId: string, input?: DataListModel): Observable<IAPIResponse> {
    let personHashId = this.authService.GetPersonHashId();
    let getContractTypeUrl = WeGoConfig.API_GET_CONTRACT_TYPE_HISTORY;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getContractTypeUrl = getContractTypeUrl + "?" + queryString + "&versionId=" + versionId;
    }
    else {
      getContractTypeUrl = getContractTypeUrl + "?versionId=" + versionId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getContractTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSpecialPeriods(sharedVehicleGroupHashId: string, input?: DataListModel): Observable<IAPIResponse> {
    let getContractTypeUrl = WeGoConfig.API_GET_SPECIAL_PERIOD_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getContractTypeUrl = getContractTypeUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
    }
    else {
      getContractTypeUrl = getContractTypeUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getContractTypeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contractType/models/contractType.service.ts